import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TokenService } from '@ninety/platform/services/services/token.service';
import { environment } from '@ninety/ui/web/environments';

export function BillingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (!req.url.startsWith(environment.billingApiOrigin)) return next(req);

  const tokenService = inject(TokenService);
  const token = tokenService.getAccessToken();
  if (!token) return next(req);

  const clonedRequest = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`),
  });
  return next(clonedRequest);
}
